export default "<div ui-view=\"modal\" class=\"shipment-modal\"></div>\n"